export default "__VITE_ASSET__DxtFgWdy__"